import {
  Dispatch,
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI
} from '@reduxjs/toolkit';
import { api } from "../../api/api";
import { RootState } from "../index";
import { logout } from "../slices/authSlice";
import { setShowSpinner } from "../slices/mainSlice";

const apiMiddleware: Middleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as any;
    if (payload.status === 401 || payload.status === 403) {
      store.dispatch(logout());
      store.dispatch(setShowSpinner(false));
    }
  }
  return next(action);
};

export const middleware = [api.middleware, apiMiddleware];